export const IMPORT_SEASON_OPTIONS = [
  'Season 1',
  'Season 2',
  'Season 3',
  'Season 4',
  'Season 5',
  'Season 6',
  'Season 7',
  'Season 8',
  'Season 9',
  'Season 10',
] as const;

export const IMPORT_STAGE_OPTIONS = [
  'Pre-Season',
  'Regular Season',
  'Wildcard',
  'Divisional',
  'Championships',
  'Super Bowl',
] as const;

export const SUPPORTED_CSV_FORMATS = [
  'stream_center_generic',
  'neonsportz_games',
  'neonsportz_teams',
] as const;

export const SAMPLE_CSV_PATH = '/lsc/samples/league_schedule_template.csv';
export const NEONSPORTZ_GAMES_SAMPLE_PATH = '/lsc/samples/neonsportz_games_sample.csv';
export const NEONSPORTZ_TEAMS_SAMPLE_PATH = '/lsc/samples/neonsportz_teams_sample.csv';
